"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Statistics = void 0;
const Log_1 = __importDefault(require("../Log"));
class Statistics {
    constructor(peerConnection, updateRateSeconds) {
        this._lastFramesDecoded = 0;
        this._lastBytesReceived = 0;
        this.stopReporting = () => {
            clearInterval(this._intervalRef);
        };
        this._intervalRef = setInterval(() => __awaiter(this, void 0, void 0, function* () {
            const stats = yield peerConnection.getStats();
            const report = {
                latency: undefined,
                frameRate: undefined,
                bitrate_mbps: undefined,
                width: undefined,
                height: undefined,
                pliCount: undefined,
                nackCount: undefined,
                packetLoss: undefined
            };
            stats.forEach((stat) => {
                // Safari
                if (stat.currentRoundTripTime && stat.type === 'candidate-pair' && stat.state === 'succeeded') {
                    report.latency = stat.currentRoundTripTime * 1000;
                }
                if (stat.type === 'inbound-rtp' && stat.mediaType === 'video') {
                    // Common stat elements
                    report.pliCount = stat.pliCount;
                    report.nackCount = stat.nackCount;
                    report.packetLoss = stat.packetsLost;
                    // Chrome
                    if (stat.totalInterFrameDelay && stat.framesDecoded) {
                        report.latency = (stat.totalInterFrameDelay / stat.framesDecoded) * 1000;
                    }
                    // Firefox
                    if (stat.jitter) {
                        report.latency = stat.jitter * 1000;
                    }
                    // Firefox, Safari
                    if (stat.bitrateMean) {
                        report.bitrate_mbps = stat.bitrateMean / 1000000;
                    }
                    else if (stat.bytesReceived) {
                        // Chrome
                        const bytesPerSecond = (stat.bytesReceived - this._lastBytesReceived) / updateRateSeconds;
                        report.bitrate_mbps = (bytesPerSecond * 8) / 1000000;
                        this._lastBytesReceived = stat.bytesReceived;
                    }
                    // Firefox
                    if (stat.framerateMean) {
                        report.frameRate = stat.framerateMean;
                    }
                }
                if (stat.type === 'track' && stat.remoteSource === true) {
                    // Chrome, Safari
                    if (stat.framesDecoded) {
                        report.frameRate = (stat.framesDecoded - this._lastFramesDecoded) / updateRateSeconds;
                        this._lastFramesDecoded = stat.framesDecoded;
                    }
                    // Chrome
                    if (stat.frameWidth && stat.frameHeight) {
                        report.width = stat.frameWidth;
                        report.height = stat.frameHeight;
                    }
                }
            });
            Log_1.default.info('Session statistics', report);
        }), updateRateSeconds * 1000);
    }
}
exports.Statistics = Statistics;
//# sourceMappingURL=Statistics.js.map